import React from "react";
import PropTypes from "prop-types";
import Webcam from "react-webcam";
import moment from "moment";
import Card from "@material-ui/core/Card";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
import DatePicker from "js/components/Shared/Form/Fields/DatePicker";
import Divider from "@material-ui/core/Divider";
import { TextField, Tooltip, Typography } from "@material-ui/core";
import ProductosField from "./Productos";
import { removeTypename } from "../../utils/Helper";
import { addImageURL, regexs } from "js/constants";
import { getUrl } from "js/utils";
import { _t } from "js/utils/TranslationService";
import CargaFacturasQraphQL from "js/graphql/resolvers/cargaFacturas.resolver";
import ParametrosCargaFacturaGraphQL from "js/graphql/resolvers/parametrosCargaFactura.resolver";
import Modal from "./modal";
import SplashScreen from "js/pages/Loading";
import { FACING_MODE_ENVIRONMENT } from "./utils";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
import ErrorList from "js/components/Shared/ErrorList";
import Chip from "@material-ui/core/Chip";
import Dialog from "@material-ui/core/Dialog";
import {
  fetchParametrosVisuales,
  getBanners,
  cleanText
} from "js/utils/helpers/FacturaPorPuntos.helpers.js";
import Fila from "js/components/Fila";
import SettingsIcon from "@material-ui/icons/Settings";
import { USER_ROLES as Roles } from "js/models/User";
import AuthService from "js/utils/AuthService";
import { SelectorCantidad } from "./SelectorCantidad";

const videoConstraints = {
  width: { min: 480 },
  height: { min: 720 },
  aspectRatio: 1.5,
  facingMode: FACING_MODE_ENVIRONMENT
};

class MyForm extends React.Component {
  constructor(props) {
    super(props);
    this.cam = React.createRef();
    this.state = {
      fileImage: null,
      fileName: "",
      imagen: [],
      isPdf: false,
      disabled: false,
      puntoVenta: "",
      numeroFactura: "",
      fechaFactura: moment().toISOString(),
      productos: [],
      detalle: "",
      openModal: false,
      imagenModal: [],
      errors: null,
      selectedProducto: null,
      selectedProductos: [],
      isLoadingImage: false,
      inBackOffice:
        window.location.pathname.indexOf("admin") !== -1 ? true : false
    };
    const { initialFilter = {} } = props;
    let dateFactura = { ...initialFilter };
    this.handleCapture = this.handleCapture.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.openModalFunction = this.openModalFunction.bind(this);
    this.getUrlFacturaImagen = this.getUrlFacturaImagen.bind(this);
    this.getFileName = this.getFileName.bind(this);
    this.takeImage = this.takeImage.bind(this);
    this.submitValue = this.submitValue.bind(this);
    this.submitImage = this.submitImage.bind(this);
  }

  componentDidMount = async () => {
    const {
      client,
      match: {
        params: { id }
      }
    } = this.props;

    const { parametrosVisuales, banners } = this.state;

    const dataParametrosVisuales = await fetchParametrosVisuales(
      id || localStorage.getItem("idPrograma"),
      client
    );

    const { data } = await client.query({
      query:
        ParametrosCargaFacturaGraphQL.queries.getParametrosCargaFacturaById,
      variables: {
        idPrograma: parseInt(id) || parseInt(localStorage.getItem("idPrograma"))
      },
      errorPolicy: "all",
      fetchPolicy: "no-cache"
    });

    let parametrosCargaFactura = {};

    if (data && data.getParametrosCargaFactura) {
      data.getParametrosCargaFactura.forEach(parametro => {
        parametrosCargaFactura[`${parametro.key}`] = parametro.value[0];
      });
    }

    let bannersUpdated = {};

    if (dataParametrosVisuales && dataParametrosVisuales.banners) {
      bannersUpdated = getBanners(dataParametrosVisuales.banners, true);

      if (bannersUpdated) {
        bannersUpdated.contenidos = cleanText(bannersUpdated);
      }
    }
    let { limitarAUnProducto = "0" } = parametrosCargaFactura;
    limitarAUnProducto = limitarAUnProducto === "1";

    this.setState({
      banners: bannersUpdated,
      ...parametrosCargaFactura,
      limitarAUnProducto
    });
  };

  validatorRegex = value => {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    const { inBackOffice } = this.state;
    let idProgramaLookFor = inBackOffice
      ? parseInt(id)
      : parseInt(localStorage.getItem("idPrograma"));
    let isInvalid = false;
    let regexVerification = regexs.find(regex => {
      return regex.idPrograma === idProgramaLookFor;
    });
    if (!regexVerification) return isInvalid;
    if (!regexVerification.regex.test(value.numeroFactura)) {
      isInvalid = true;
    }
    return isInvalid;
  };

  submitValueDate = e => {
    this.setState(({}) => ({
      fechaFactura: e.target.value
    }));
  };

  handleProductSelect = event => {
    this.setState({ selectedProducto: event.target.value });
  };

  handleChange = key => event => {
    this.setState({ [key]: event.target.value });
  };

  handleCapture = value => {
    this.setState({
      isCapture: value
    });
  };

  handleDeleteFileImage = () => {
    this.setState({
      fileImage: null,
      fileName: "",
      imagen: [],
      imagenModal: [],
      disabled: false
    });
  };

  handleCleanImage = () => {
    this.setState({ fileImage: null });
  };

  handleDisabled = () => {
    this.setState({ disabled: true });
  };

  handleDeleteProducto = value => {
    const arr = this.state.selectedProductos;
    const objWithIdIndex = arr.findIndex(obj => obj.value === value);
    if (objWithIdIndex > -1) {
      arr.splice(objWithIdIndex, 1);
    }

    this.setState({ selectedProductos: arr });
  };

  handleSubProducto = index => {
    const arr = this.state.selectedProductos;
    if (arr[index].cantidad === 1) return;
    arr[index].cantidad--;
    this.setState({ selectedProductos: arr });
  };

  handleAddProducto = index => {
    const arr = this.state.selectedProductos;
    const defaultValue = parseInt(this.state.cantidadProductosXDefault);
    arr[index].cantidad++;
    this.setState({ selectedProductos: arr });
  };

  openModalFunction = value => {
    this.setState({
      openModal: value,
      disabled: false
    });
  };

  getUrlFacturaImagen = value => {
    this.setState({ imagenModal: value });
  };

  getFileName = value => {
    this.setState({
      fileName: value
    });
  };

  takeImage = async () => {
    const imagenCam = this.cam.current.getScreenshot();
    this.setState({
      fileImage: imagenCam
    });
    const mensaje = "Imagen capturada correctamente.";
    return this.props.openNotification(mensaje);
  };

  configBOParams = id => {
    if (this.props.match.url.includes("admin")) {
      return (
        <Tooltip title="Parámetros Venta de facturas">
          <IconButton
            color="primary"
            onClick={() =>
              this.props.history.push(
                `/admin/programa/${parseInt(id)}/parametros-carga-facturas`
              )
            }
          >
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      );
    }
  };

  async submitImage() {
    if (!this.state.fileImage) throw new Error("No hay imagen para cargar.");

    try {
      const response = await fetch(this.state.fileImage);
      const blob = await response.blob();
      const file = new File([blob], "Carga de factura", { type: "image/jpg" });

      const { height, width } = { height: 2048, width: 1536 };
      const formData = new window.FormData();
      formData.append("image", file);
      formData.append("context", "cargaFactura");
      formData.append("height", height);
      formData.append("width", width);

      this.setState({ isLoadingImage: true });
      const uploadResponse = await fetch(addImageURL, {
        method: "POST",
        credentials: "include",
        body: formData
      });
      const { url } = await uploadResponse.json();
      const imageUrl = getUrl(url);
      if (!imageUrl) {
        throw new Error("La URL de la imagen no es válida.");
      }

      this.setState(prevState => ({
        imagen: prevState.imagen.concat(imageUrl),
        isLoadingImage: false
      }));
      this.props.openNotification("Imagen guardada correctamente.");
      return imageUrl;
    } catch (error) {
      console.error("Error al cargar la imagen:", error);
      this.setState({ isLoadingImage: false });
      throw new Error(
        "No se pudo subir la imagen. Por favor, intentá de nuevo."
      );
    }
  }

  async getPuntosProducto(codigo) {
    const {
      client,
      match: {
        params: { id }
      }
    } = this.props;

    let idPrograma = parseInt(id || localStorage.getItem("idPrograma"));

    const { data, errors } = await client.query({
      query: CargaFacturasQraphQL.queries.getPuntosProducto,
      variables: {
        idPrograma,
        codigo
      },
      errorPolicy: "all",
      fetchPolicy: "no-cache"
    });

    if (data.getPuntosProducto.puntos) return data.getPuntosProducto.puntos;
    else if (errors) {
      this.setState({ errors: errors });
      return 0;
    }
  }

  updateAutocompleteQueryParams = key => async select => {
    const {
      cantidadProductosXDefault,
      limitarAUnProducto = false
    } = this.state;
    const arr = this.state.selectedProductos;
    // Chequeamos que no se encuentre agregado
    if (arr.findIndex(p => p.value === select[0].value) > -1) return;
    const value = select.map(option => option);
    let puntos = await this.getPuntosProducto(select[0].value);
    let obj = [...this.state.selectedProductos];

    let productoToAdd = {
      cantidad: parseInt(cantidadProductosXDefault),
      puntos: parseInt(cantidadProductosXDefault) * puntos,
      ...value[0]
    };

    if (limitarAUnProducto) {
      obj = [productoToAdd];
    } else {
      obj.push(productoToAdd);
    }

    return this.setState({ selectedProductos: obj });
  };

  async submitValue() {
    const {
      puntoVenta,
      numeroFactura,
      fechaFactura,
      detalle,
      selectedProductos,
      imagenModal,
      inBackOffice,
      imagen
    } = this.state;
    const {
      match: {
        params: { id }
      },
      client,
      history
    } = this.props;

    if (
      numeroFactura === "" ||
      puntoVenta === "" ||
      fechaFactura === "" ||
      !selectedProductos
    ) {
      return this.props.openNotification(
        "Debe completar los campos obligatorios."
      );
    }

    if (this.validatorRegex({ numeroFactura })) {
      return this.props.openNotification(
        "El formato del campo 'Número de Factura' es inválido."
      );
    }

    if (selectedProductos.length === 0) {
      return this.props.openNotification("Debe agregar al menos un producto.");
    }

    let facturaUrl = "";
    try {
      if (imagenModal[0]) {
        facturaUrl = imagenModal[0];
      } else if (imagen[0]) {
        facturaUrl = imagen[0];
      } else {
        facturaUrl = await this.submitImage();
      }
      if (!facturaUrl) {
        return this.props.openNotification(
          "Debe cargar una imagen de la factura antes de enviar."
        );
      }
    } catch (error) {
      return this.props.openNotification(error.message);
    }

    let variables = {};

    const transformProducts = () => {
      return selectedProductos.map(prod => {
        return {
          codigo: prod.value,
          nombre: prod.label,
          cantidad: prod.cantidad,
          puntos: prod.puntos
        };
      });
    };

    variables.idPrograma = parseInt(id || localStorage.getItem("idPrograma"));
    variables.idUsuario = parseInt(localStorage.getItem("idUsuario"));
    variables.puntoVenta = puntoVenta;
    variables.numeroFactura = numeroFactura;
    variables.fechaFactura = fechaFactura;
    variables.detalle = detalle;
    variables.productos = transformProducts();
    variables.facturaUrl = facturaUrl;
    variables.estado = "PENDIENTE_APROBACION";

    await client
      .mutate({
        mutation: CargaFacturasQraphQL.mutations.createCargaFactura,
        variables: {
          cargaFactura: { ...removeTypename(variables) }
        }
      })
      .then(res => {
        const mensaje = _t("Factura enviada");
        this.props.openNotification(mensaje);
        if (!inBackOffice) {
          history.push(`/landing`);
        } else {
          history.push(`/admin/programa/${id}/moderacion`);
        }
      })
      .catch(errors => {
        if (errors.toString().includes("error al enviar el mail")) {
          this.props.openNotification("Error al enviar el mail");
          if (!inBackOffice) {
            history.push(`/landing`);
          } else {
            history.push(`/admin/programa/${id}/moderacion`);
          }
        } else {
          this.setState({ errors: errors });
          return false;
        }
      });
  }

  render() {
    const {
      classes,
      match: {
        params: { id }
      },
      search
    } = this.props;
    const {
      isCapture,
      disabled,
      openModal,
      selectedProductos,
      inBackOffice,
      banners,
      showSelectorCantidad,
      cantidadProductosXDefault
    } = this.state;

    const btnsNextTitle = [];
    btnsNextTitle.push({
      title: _t("Cargar Factura"),
      btn: this.configBOParams(parseInt(id)),
      perms: [Roles.PARAMETROS_CARGA_FACTURA_W],
      titleTranslation: false
    });

    return (
      <>
        {banners &&
          banners.visible &&
          !inBackOffice && (
            <div style={{ marginBottom: "1.5%" }}>
              <Fila {...banners} baseLink={"Banners Performance"} />
            </div>
          )}
        {btnsNextTitle.map((btnNextTitle, i) => {
          if (AuthService.hasPerms(btnNextTitle.perms)) {
            return (
              <React.Fragment key={i}>
                <Typography gutterBottom variant="h5">
                  {typeof btnNextTitle.titleTranslation !== "undefined" &&
                  !btnNextTitle.titleTranslation
                    ? btnNextTitle.title
                    : _t(btnNextTitle.title) || _t("Listado")}
                  {btnNextTitle.btn}
                </Typography>
              </React.Fragment>
            );
          }
        })}
        <Card className={classes.card} raised>
          <Grid container spacing={16} className={classes.gridCard}>
            {/*cambio cliente por punto venta */}
            <Grid item xs={12} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  required={true}
                  id="puntoVenta"
                  name={"punto de venta"}
                  label={_t("Punto de Venta")}
                  value={this.state.puntoVenta}
                  onChange={this.handleChange("puntoVenta")}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  required={true}
                  id={"numeroFactura"}
                  name={"numeroFactura"}
                  label={_t("Nro Factura")}
                  value={this.state.numeroFactura}
                  onChange={this.handleChange("numeroFactura")}
                />
              </FormControl>
            </Grid>
            {/* fecha de factura debe ser formateo liza dd/mm/aaaa */}
            {/* fecha de creacion para poder realizar el filtro en la moderación,
              fecha de factura es laque manda en el filtro de busqueda */}
            <Grid item xs={12} md={4}>
              <FormControl className={classes.formControl}>
                <DatePicker
                  key={"fechaFactura"}
                  name={"fechaFactura"}
                  label={_t("Fecha Factura")}
                  input={{
                    onChange: date =>
                      this.submitValueDate({
                        target: {
                          name: "fechaFactura",
                          value: date.toISOString()
                        }
                      }),
                    value: moment(this.state.fechaFactura)
                  }}
                  format={"DD/MM/YYYY"}
                  autoOk={true}
                  startOfDate
                  disableFuture
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl className={classes.formControl}>
                <TextField
                  id={"detalle"}
                  name={"detalle"}
                  label={_t("Detalle")}
                  value={this.state.detalle}
                  onChange={this.handleChange("detalle")}
                  className={classes.textField}
                  margin="normal"
                  multiline
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl className={classes.formControl}>
                <ProductosField
                  noOptionsMessage={`No hay ${_t("Productos").toLowerCase()}`}
                  onChange={this.updateAutocompleteQueryParams(
                    "selectedProductos"
                  )}
                  value={selectedProductos}
                  multiple={true}
                  search={search}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <List dense>
                {selectedProductos.map((producto, index) => {
                  return (
                    <SelectorCantidad
                      index={index}
                      producto={producto}
                      handleSubProducto={this.handleSubProducto}
                      handleDeleteProducto={this.handleDeleteProducto}
                      handleAddProducto={this.handleAddProducto}
                      showSelectorCantidad={showSelectorCantidad}
                      cantidadProductosXDefault={cantidadProductosXDefault}
                    />
                  );
                })}
              </List>
            </Grid>
          </Grid>
          {isCapture ? (
            <>
              {!this.state.fileImage ? (
                <>
                  <Dialog
                    open={isCapture && !this.state.fileImage}
                    PaperProps={{ className: classes.dialogContent }}
                  >
                    <Webcam
                      className={classes.webcam}
                      audio={false}
                      // height={200}
                      // width={200}
                      ref={this.cam}
                      screenshotFormat="imagen/jpeg"
                      videoConstraints={videoConstraints}
                    />
                    <CardActions className={classes.actionContainer}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.setState({ isCapture: false })}
                      >
                        {_t("Cancelar")}
                      </Button>
                      <Button
                        onClick={this.takeImage}
                        variant="contained"
                        color="primary"
                      >
                        {_t("Captura")}
                      </Button>
                    </CardActions>
                  </Dialog>
                </>
              ) : (
                <>
                  <Divider style={{ marginBottom: "5px", marginTop: "5px" }} />

                  <img
                    style={{ width: "100%", padding: "10px" }}
                    src={this.state.fileImage}
                  />
                  <Divider style={{ marginBottom: "5px", marginTop: "5px" }} />

                  <CardActions className={classes.actionContainer}>
                    <Button
                      onClick={() => this.handleCleanImage()}
                      variant="contained"
                      color="primary"
                    >
                      {_t("Volver a Intentar")}
                    </Button>
                  </CardActions>
                </>
              )}
            </>
          ) : (
            <>
              <Divider style={{ marginBottom: "5px", marginTop: "5px" }} />
              <CardActions className={classes.actionContainer}>
                {/* COLOCAR NOMBRE DEL ARCHIVO SUBIDO Y LA POSIBILIDAD DE ELIMINARLO */}
                <Button
                  disabled={this.state.isCapture}
                  onClick={() => this.openModalFunction(true)}
                  variant="contained"
                  color="primary"
                >
                  {_t("Subir imagen")}
                </Button>
                {!isCapture &&
                  !openModal &&
                  this.state.imagenModal[0] && (
                    <Chip
                      label={this.state.fileName}
                      deleteIcon
                      color="black"
                      onDelete={this.handleDeleteFileImage}
                      variant="outlined"
                    />
                  )}
                {openModal ? (
                  <Modal
                    disabled={disabled}
                    openModalFunction={this.openModalFunction}
                    getUrlFacturaImagen={this.getUrlFacturaImagen}
                    getFileName={this.getFileName}
                    handleDisabled={this.handleDisabled}
                  />
                ) : null}
                <Button
                  disabled={disabled}
                  onClick={() => this.handleCapture(true)}
                  variant="contained"
                  color="primary"
                >
                  {_t("Capturar Imagen")}
                </Button>
              </CardActions>
            </>
          )}

          {this.state.isLoadingImage && (
            <Grid container item style={{ height: 100 }}>
              <SplashScreen className={classes.progress} />
            </Grid>
          )}
          <Divider style={{ marginBottom: "5px", marginTop: "5px" }} />
          <CardActions className={classes.actionContainer}>
            <FormControl className={classes.formControl}>
              <Button
                type="submit"
                onClick={this.submitValue}
                variant="contained"
                color="primary"
              >
                Enviar
              </Button>
            </FormControl>
          </CardActions>
          <CardActions className={classes.actionContainer}>
            <ErrorList errors={this.state.errors} belowInput />
          </CardActions>
        </Card>
      </>
    );
  }
}

MyForm.propTypes = {
  classes: PropTypes.object.isRequired,
  submitValue: PropTypes.func.isRequired
};

export default MyForm;
